import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const Timer = () => {
    const [timeLeft, setTimeLeft] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const timeZone = "America/New_York";
            const now = new Date();
            
            // Get current US Eastern time parts
            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone,
                year: 'numeric', month: 'numeric', day: 'numeric',
                hour: 'numeric', minute: 'numeric', second: 'numeric',
                hour12: false
            });
            const parts = formatter.formatToParts(now);
            const getPart = (type) => parseInt(parts.find(p => p.type === type).value, 10);
            
            const year = getPart('year');
            const month = getPart('month') - 1;
            const day = getPart('day');
            const hours = getPart('hour');
            const minutes = getPart('minute');
            const seconds = getPart('second');

            // Date object representing current time in New York
            const nyTime = new Date(year, month, day, hours, minutes, seconds);
            const dayOfWeek = nyTime.getDay(); // 0 is Sunday, 6 is Saturday

            let targetTime = new Date(year, month, day, 9, 30, 0); // Today at 9:30 AM NY
            let closeTime = new Date(year, month, day, 16, 0, 0); // Today at 4:00 PM NY
            
            let targetIsClose = false;

            if (dayOfWeek === 0 || dayOfWeek === 6) {
                // Weekend: Target is next Monday at 9:30 AM
                const daysToAdd = dayOfWeek === 0 ? 1 : 2;
                targetTime.setDate(targetTime.getDate() + daysToAdd);
            } else {
                if (nyTime < targetTime) {
                    // Before market opens today
                } else if (nyTime >= targetTime && nyTime < closeTime) {
                    // Market is currently open
                    targetIsClose = true;
                    targetTime = closeTime;
                } else {
                    // After market closed today
                    if (dayOfWeek === 5) {
                        // It's Friday evening, target is next Monday
                        targetTime.setDate(targetTime.getDate() + 3);
                    } else {
                        // Monday-Thursday evening, target is tomorrow
                        targetTime.setDate(targetTime.getDate() + 1);
                    }
                }
            }

            setIsOpen(targetIsClose);

            const diff = targetTime - nyTime;
            
            if (diff > 0) {
                const h = Math.floor((diff / (1000 * 60 * 60)));
                const m = Math.floor((diff / (1000 * 60)) % 60);
                const s = Math.floor((diff / 1000) % 60);
                setTimeLeft(`${h}h ${m}m ${s}s`);
            } else {
                setTimeLeft("0h 0m 0s");
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Typography variant="h3" align="center" style={{ width: "100%" }}>
                {isOpen ? "Market Closes In" : "Market Opens In"}
            </Typography>
            <Typography variant="h3" align="center" style={{ width: "100%", letterSpacing: "2px" }}>
                {timeLeft}
            </Typography>
        </Box>
    );
};

export default Timer;
